<template>
  <div class="dashboard-editor-container">
    <el-row
      type="flex"
      justify="space-between"
      style="background:#fff; padding:16px 0 0 0; margin-bottom:32px;"
    >
      <el-col :span="12" v-for="(item,index) in cardData" :key="index" style="padding: 0;">
        <CoreCard :cardInfo="item"/>
      </el-col>
    </el-row>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <div>
        <shandong-map
              v-if="fullScanData.length > 0"
              :map-data="fullScanData"
              :visual-map-pieces="customPieces"
              :show-visual-map="true"
              title-text="稽查窜货预警热力图-年"
              height="500px"
            />
          <!-- 加载状态 -->
              <div
                v-else
                style="
                  width: 100%;
                  height: 500px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border: 1px solid #ddd;
                  border-radius: 8px;
                  background: #f9f9f9;
                  font-size: 16px;
                  color: #666;
                "
              >
                数据加载中...
              </div>
        </div>

      </el-col>
    </el-row>

  </div>
</template>

<script>
import CoreCard  from"../components/CoreCard.vue";
import ShandongMap from '../components/ShandongMap.vue';import { scanInspectCurYearByArea,scanInspectAllCount,scanInspectOneWeek } from "@/api/board";
export default {
  name: "InspectionManagement",
  components: {
    CoreCard,
    ShandongMap,
  },
  data() {
    return {
      cardData:[
          {
            titleOne:"疑似稽查窜货事件总数",
            numOne:0,
             marginTop:'0%'
          },
          {
            titleOne:"本周新增稽查预警数",
            numOne:0,
            marginTop:'0%'
          },
      ],
      scanInspect: [],
      allCities: [
        '济南市', '青岛市', '淄博市', '枣庄市', '东营市',
        '烟台市', '潍坊市', '济宁市', '泰安市', '威海市',
        '日照市', '临沂市', '德州市', '聊城市', '滨州市',
        '菏泽市','莱芜市'
      ],
      customPieces: [
        { gt: 100, label: '> 100 次', color: '#3c82e1' },
        { gte: 50, lte: 100, label: '50 - 100次', color: '#27e1e6' },
        { gte: 20, lt: 50, label: '10 - 50 次', color: '#e1783c' },
        { gt: 0, lt: 20, label: '1 - 10 次', color: '#e6e622' },
        { value: 0, label: '无扫码', color: '#3ce15a' }
      ],
    };
  },
  computed: {
    fullScanData() {
      console.log('allCities:', this.allCities);        // 看看是否为空
      console.log('scanInspect:', this.scanInspect);          // 看看是否有数据
      const result = this.allCities.map(name => {
        const item = this.scanInspect.find(d => d.name === name);
        return {
          name,
          value: item ? item.value : 0
        };
      });
      console.log('fullScanData:', result); // 看看结果
      return result;
    }
  },

  mounted() {
    this.getScanInspectAllCount();
    this.getScanInspectOneWeek();
    this.getShandongMapOne();
  },
  methods: {
    //疑似窜货事件总数
    getScanInspectAllCount(){
     scanInspectAllCount().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[0].numOne = response.data;
          console.log('疑似窜货事件总数.data',response.data)
        }
      });
    },
    //本周新增预警数
    getScanInspectOneWeek(){
     scanInspectOneWeek().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[0].numOne = response.data;
          console.log('本周新增预警数.data',response.data)
        }
      });
    },
    getShandongMapOne() {
      // 当前年窜货预警分布
      scanInspectCurYearByArea().then(response => {
          if(response && response.status_code == 200 && response.data){
            let chartData = {}
            chartData.mapdata = [];
            for (let i = 0; i < response.data.length; i++) {
              const obj = {
                name: response.data[i].cityCodeScan,
                value: response.data[i].qty
              };
              chartData.mapdata.push(obj);
            }
            this.scanInspect = chartData.mapdata;
            console.log("窜货预警热力图",this.scanInspect );
         }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }
  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
</style>
